/** TipTap min-height for document org-settings and paired create-modal editors (half of shared Editor default 300px). */
export const DOCUMENT_SETTINGS_EDITOR_CONTENT_MIN_HEIGHT = "150px";

/** @deprecated Use DOCUMENT_SETTINGS_EDITOR_CONTENT_MIN_HEIGHT — kept for BOL call sites. */
export const BOL_PDF_EDITOR_CONTENT_MIN_HEIGHT = DOCUMENT_SETTINGS_EDITOR_CONTENT_MIN_HEIGHT;
